export default __webpack_public_path__ + "static/media/undraw_onboarding_o8mv.74d12a63.png";